// Tabs
document.querySelectorAll(".tab").forEach(tab => {
  tab.addEventListener("click", () => {
    document.querySelector(".tab.active")?.classList.remove("active");
    tab.classList.add("active");

    document.querySelector(".tab-content.active")?.classList.remove("active");
    document.getElementById(tab.dataset.tab).classList.add("active");
  });
});

// image Uplod..

const fileInput = document.getElementById("fileInput");
const uploadBox = document.getElementById("uploadBox");
const previewBox = document.getElementById("previewBox");
const previewImage = document.getElementById("previewImage");
const changePhotoBtn = document.getElementById("changePhotoBtn");

uploadBox.addEventListener("click", () => fileInput.click());

// Upload first time
fileInput.addEventListener("change", function () {
  const file = this.files[0];
  if (file) {
    const imgURL = URL.createObjectURL(file);
    previewImage.src = imgURL;

    uploadBox.style.display = "none";
    previewBox.style.display = "flex";
  }
});

changePhotoBtn.addEventListener("click", function () {
  fileInput.click();
});

fileInput.addEventListener("change", function () {
  const file = this.files[0];
  if (file) {
    const imgURL = URL.createObjectURL(file);
    previewImage.src = imgURL; 
  }
});


// Update Summary text


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".option-group").forEach(group => {
    const selectedLabel = group.querySelector(".option-selected");
    const radios = group.querySelectorAll('input[type="radio"]');

    radios.forEach(radio => {
      radio.addEventListener("change", function () {
        selectedLabel.textContent = this.dataset.label;
      });
    });
  });
});


// Continue button click

const tabs = document.querySelectorAll(".tab");
const continueBtns = document.querySelectorAll(".continue-btn");
const backBtn = document.querySelector(".back-btn");

// Active Tab
function getActiveTab() {
  return document.querySelector(".tab.active");
}

// Activate Tab
function activateTab(tab) {
  tabs.forEach(t => t.classList.remove("active"));
  tab.classList.add("active");
  toggleBackButton(); // check visibility
}

// Toggle Back button visibility
function toggleBackButton() {
  const activeTab = getActiveTab();
  const index = Array.from(tabs).indexOf(activeTab);

  if (index === 0) {
    backBtn.style.display = "none";   // hide on first tab
  } else {
    backBtn.style.display = "flex";   // show on others
  }
}

// Tab click
tabs.forEach(tab => {
  tab.addEventListener("click", () => activateTab(tab));
});

// Continue
continueBtns.forEach(btn => {
  btn.addEventListener("click", () => {
    const activeTab = getActiveTab();
    const nextTab = activeTab.nextElementSibling;

    if (nextTab && nextTab.classList.contains("tab")) {
      nextTab.click();
    }
  });
});

// Back
backBtn.addEventListener("click", () => {
  const activeTab = getActiveTab();
  const prevTab = activeTab.previousElementSibling;

  if (prevTab && prevTab.classList.contains("tab")) {
    prevTab.click();
  }
});

// Run initial check
toggleBackButton();



const summaryBtn = document.querySelectorAll(".summary-btn");
const summaryPanel = document.querySelector(".customizer-panel.summary-card");
const customizePanel = document.querySelector(".customizer-panel:not(.summary-card)");
const summaryContainer = document.getElementById("summaryContainer");
const backBtn_c = document.querySelector(".back-btn");

// Create summary rows
function buildSummary() {
  summaryContainer.innerHTML = ""; // reset

  document.querySelectorAll(".option-group").forEach(group => {
    const selected = group.querySelector("input[type='radio']:checked");
    if (!selected) return;

    const labelTitle = group.querySelector(".option-title").innerText.trim();
    const valueText = selected.dataset.label;

    // check if image is available
    const img = selected.closest("label").querySelector("img");

    // check if color background circle exist
    const colorCircle = selected.closest("label").querySelector(".tint-circle-inner");

    // build row
    const row = document.createElement("div");
    row.className = "summary-row";
    row.innerHTML = `
      <span class="label">${labelTitle}</span>
      <div class="value">
        <span class="text">${valueText}</span>
        ${
          img
            ? `<span class="circle-icon"><img src="${img.src}" /></span>`
            : colorCircle
            ? `<span class="circle-icon"><span class="circle_menu" style="background:${colorCircle.style.background};"></span></span>`
            : ""
        }
      </div>
    `;

    summaryContainer.appendChild(row);
  });

  // Add selfie row
  if (typeof previewImage !== "undefined" && previewImage.src) {
    const selfieRow = document.createElement("div");
    selfieRow.className = "summary-row selfie-row";
    selfieRow.innerHTML = `
      <span class="label">Selfie</span>
      <div class="selfie-preview">
        <img src="${previewImage.src}" style="width:100px;height:100px;border-radius:16px;object-fit:cover;">
      </div>
    `;
    summaryContainer.appendChild(selfieRow);
  }
}

// SUMMARY BUTTON CLICK
summaryBtn.forEach(btn => {
  btn.addEventListener("click", () => {
    buildSummary();
    customizePanel.style.display = "none";
    summaryPanel.style.display = "flex";
  });
});

// BACK BUTTON
backBtn_c.addEventListener("click", () => {
  summaryPanel.style.display = "none";
  customizePanel.style.display = "block";
});
